export default "__VITE_ASSET__JmAb0kEn__"